var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateArcana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13376 0.0627117C8.71631 0.0687129 10.3084 0.585642 11.6432 1.64458C14.7965 4.14627 15.3195 8.72355 12.8111 11.8685C10.3027 15.0134 5.71314 15.5349 2.55981 13.0332C1.22506 11.9743 0.361857 10.5436 0 9.00698C0.21881 11.1137 1.25351 13.1347 3.04693 14.5576C6.58619 17.3653 11.7375 16.7802 14.5528 13.2504C17.3681 9.72058 16.7814 4.583 13.2421 1.77525C11.4487 0.352414 9.24172 -0.198341 7.13404 0.0627117H7.13376Z",
    fill: "#BF96FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7768 13.0351L10.2324 13.5045L10.3142 13.0146L10.7768 13.0351L11.0011 13.171L10.974 12.6133L10.7768 13.0351Z",
    fill: "#BF96FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0011 13.1711L10.2324 13.5045L10.7768 13.0352L11.0011 13.1711Z",
    fill: "#BF96FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9742 12.6133L10.3145 13.0146L10.777 13.0351L10.9742 12.6133Z",
    fill: "#BF96FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55007 14.9727L7.36133 15.1308L7.52463 15.6869L7.55007 14.9727Z",
    fill: "#BF96FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55083 14.9727L7.77021 15.1461L7.52539 15.6869",
    fill: "#BF96FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19922 13.1855L7.26536 15.6447L7.10726 14.8793L4.19922 13.1855Z",
    fill: "#BF96FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26536 15.6447L5.03599 14.8079L4.19922 13.1855L5.39296 14.6394L7.26536 15.6447Z",
    fill: "#BF96FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10726 14.8793L6.86244 14.4966L4.19922 13.1855L5.39296 14.6394L5.03599 14.8079L4.19922 13.1855L5.39296 14.6394L7.26536 15.6447L7.10726 14.8793Z",
    fill: "#BF96FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26536 15.6447L4.19922 13.1855L7.10726 14.8793L7.26536 15.6447Z",
    fill: "#BF96FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19922 13.1855L5.39296 14.6394L5.03599 14.8079L4.19922 13.1855Z",
    fill: "#BF96FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97266 12.8497L9.02353 12.7223L9.58485 12.5488L9.97246 12.6355L9.78891 13.2376L9.18192 13.1558L8.97266 12.8497Z",
    fill: "#BF96FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58652 12.5488L9.18359 13.1558L9.97413 12.6355",
    fill: "#BF96FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78982 13.2375L8.54492 14.0231L8.97356 12.8496L9.18282 13.1557L8.54492 14.0231L9.18282 13.1557L9.78982 13.2375Z",
    fill: "#BF96FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18282 13.1562L8.54492 14.0237L9.78982 13.238L9.18282 13.1562Z",
    fill: "#BF96FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.466 14.7891L11.7148 15.7153V15.2959L12.466 14.7891Z",
    fill: "#BF96FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7162 15.7156L9.30469 15.8641L11.7162 15.2962L11.2706 14.6934L12.4674 14.7894L11.7162 15.2962V15.7156Z",
    fill: "#BF96FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30469 15.8641L11.2706 14.6934L11.7162 15.2962L9.30469 15.8641Z",
    fill: "#BF96FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49584 8.65039L6.45508 9.05851L6.60826 9.30852L6.77157 8.95156L6.49584 8.65039Z",
    fill: "#BF96FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49609 8.65039L6.56776 9.02787L6.77183 8.95156",
    fill: "#BF96FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45508 9.05798L6.5675 9.02734L6.60826 9.30799",
    fill: "#BF96FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 11.5142L6.19311 10.6211L6.62422 11.2929L6.33344 11.2634L6.125 11.5142Z",
    fill: "#BF96FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19311 10.6211L6.33344 11.2634L6.60151 12.0019L6.62422 11.2929L6.60151 12.0019L6.125 11.5142L6.33344 11.2634L6.62422 11.2929",
    fill: "#BF96FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62476 11.2932L6.33398 11.2637L6.60206 12.0022",
    fill: "#BF96FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21282 6.125L7 6.78041L7.17944 7.20413L7.54544 6.75744L7.21282 6.125Z",
    fill: "#BF96FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21289 6.125L7.30507 6.57991L7.54552 6.75744L7.21289 6.125Z",
    fill: "#BF96FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.78057L7.305 6.58008L7.17944 7.2043L7 6.78057Z",
    fill: "#BF96FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17423 11.334L9.13867 11.8034L9.27626 11.9817L9.39361 11.686L9.17423 11.334Z",
    fill: "#BF96FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39361 11.686L9.17423 11.334L9.25602 11.7421L9.39361 11.686L9.25602 11.7421L9.13867 11.8034L9.25602 11.7421L9.27626 11.9817L9.13867 11.8034L9.17423 11.334",
    fill: "#BF96FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2761 11.9812L9.39345 11.6855L9.25586 11.7416L9.2761 11.9812Z",
    fill: "#BF96FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13867 11.8035L9.25602 11.7422L9.27626 11.9818",
    fill: "#BF96FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17383 11.334L9.25562 11.7421L9.39321 11.686",
    fill: "#BF96FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26623 9.45508L8.59769 10.5919L8.427 10.7782L8.32031 9.67528L8.55994 9.79126L9.26623 9.45508Z",
    fill: "#BF96FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55994 9.79125L8.51289 9.24526L8.32031 9.67526L8.55994 9.79125L9.26623 9.45507L8.84032 8.86914",
    fill: "#BF96FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26501 9.45507L8.59647 10.5919L8.42578 10.7782L8.55872 9.79125L8.8391 8.86914L8.51167 9.24526L8.55872 9.79125",
    fill: "#BF96FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59647 10.5917L8.55872 9.79102L8.42578 10.778L8.59647 10.5917Z",
    fill: "#BF96FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3379 8.67578L10.6333 9.02291L10.702 9.07733L10.6653 8.70888L10.5937 8.7573L10.3379 8.67578Z",
    fill: "#BF96FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5937 8.75754L10.5737 8.57536L10.6653 8.70912L10.5937 8.75754L10.3379 8.67602L10.4407 8.46484",
    fill: "#BF96FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3379 8.67602L10.6333 9.02315L10.702 9.07758L10.5937 8.75754L10.4407 8.46484L10.5737 8.57536L10.5937 8.75754",
    fill: "#BF96FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6334 9.02342L10.5938 8.75781L10.7021 9.07785L10.6334 9.02342Z",
    fill: "#BF96FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07174 9.50781L3.71094 9.79694L3.96096 9.71981L4.07174 9.50781Z",
    fill: "#BF96FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96113 9.71814L4.04128 9.82918L4.27598 10.1555L4.17641 10.6878L4.05414 10.9964L3.96879 10.6761L3.55273 10.3128L3.71112 9.79527L4.07192 9.50586L3.96113 9.71814Z",
    fill: "#BF96FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96879 10.6758L3.55273 10.3125L3.79345 10.7601L4.05386 10.9961L3.96879 10.6758L4.27598 10.1553L4.07165 9.50586L3.96879 10.6758Z",
    fill: "#BF96FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05386 10.9961L3.79345 10.76L3.55273 10.3125L3.96879 10.6758L4.05386 10.9961Z",
    fill: "#BF96FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27594 10.1562L3.96875 10.6768L4.05382 10.9971L4.1761 10.6888L4.27594 10.1562Z",
    fill: "#BF96FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71094 9.79527L3.96096 9.71814L4.07174 9.50586L3.71094 9.79527Z",
    fill: "#BF96FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07172 9.50586L3.96094 9.71814L4.043 9.8333L3.96887 10.6758L4.27606 10.1553L4.07172 9.50586Z",
    fill: "#BF96FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M4.043 9.8333L4.07172 9.50586L3.96094 9.71814",
    fill: "#BF96FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49978 12.6681L3.47461 12.3798L3.62725 12.2129L3.49978 12.6681Z",
    fill: "#BF96FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25195 12.2682L3.38927 12.0078L3.62753 12.2138L3.38927 12.0078L3.47489 12.3806L3.25195 12.2682L3.50006 12.669L3.47489 12.3806L3.62753 12.2138L3.47489 12.3806L3.38927 12.0078L3.47489 12.3806L3.62753 12.2138L3.38927 12.0078L3.25195 12.2682Z",
    fill: "#BF96FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47489 12.3806L3.38927 12.0078L3.25195 12.2682L3.47489 12.3806L3.62753 12.2138L3.47489 12.3806Z",
    fill: "#BF96FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97461 7.17578L9.00032 7.45123L9.23994 7.56339L9.42869 7.58391L9.22982 7.28301L8.97461 7.17578Z",
    fill: "#BF96FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15268 7.33671L9.32174 7.16602L9.15268 7.33671L8.97461 7.17614L9.32174 7.16602L9.42869 7.58426",
    fill: "#BF96FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15268 7.33671L9.32174 7.16602L8.97461 7.17614L9.15268 7.33671L9.00032 7.45159L9.23994 7.56375",
    fill: "#BF96FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39426 7.49219L5.10321 7.82892L5.08789 8.07893L5.36855 7.8136L5.22576 7.82892L5.08789 8.07893L5.22576 7.82892H5.10321H5.22576L5.39426 7.49219Z",
    fill: "#BF96FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36855 7.81445L5.22576 7.82977L5.08789 8.07978L5.36855 7.81445Z",
    fill: "#BF96FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36855 7.8136L5.39426 7.49219L5.22576 7.82892H5.10321L5.08789 8.07893L5.22576 7.82892L5.36855 7.8136Z",
    fill: "#BF96FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39429 7.49227L5.10352 7.82901H5.22606C5.22606 7.82901 5.39429 7.48598 5.39429 7.49227Z",
    fill: "#BF96FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71805 14.8519L3.97593 14.6602L3.88867 14.6654L4.71805 14.8519Z",
    fill: "#BF96FF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82609 14.1856L3.87916 13.7812L3.72461 14.1653L3.82609 14.1856L3.97627 14.6604L3.88901 14.6656L3.72461 14.1653",
    fill: "#BF96FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97627 14.6604L3.87916 13.7812L3.82609 14.1856L3.72461 14.1653L3.88901 14.6656L4.71839 14.8522L4.54962 14.6268L4.14012 13.9388L3.87916 13.7812L4.54962 14.6268L3.97627 14.6604L4.71839 14.8522L3.97627 14.6604Z",
    fill: "#BF96FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97627 14.6592L3.82609 14.1843L3.72461 14.1641L3.88901 14.6644L3.97627 14.6592Z",
    fill: "#BF96FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82617 14.1856L3.97635 14.6604L4.54969 14.6268L3.87924 13.7812L3.82617 14.1856Z",
    fill: "#BF96FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82609 14.1843L3.97627 14.6592L3.88901 14.6644L3.72461 14.1641L3.82609 14.1843Z",
    fill: "#BF96FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54919 14.627L4.51172 14.7987L4.71797 14.8524",
    fill: "#BF96FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96825 13.5958L7.51424 12.8203L6.63672 13.5652L6.96825 13.5958L8.11112 13.6062L8.38657 13.499L7.51424 12.8203L6.63672 13.5652L6.96825 13.5958L7.54488 14.9173L6.63672 13.5652L7.51424 12.8203L6.96825 13.5958Z",
    fill: "#BF96FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54538 14.9173L6.96875 13.5958L8.11161 13.6062L6.96875 13.5958L7.51474 12.8203L8.11161 13.6062L7.54538 14.9173L8.38707 13.499L7.54538 14.9173Z",
    fill: "#BF96FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54538 14.9172L6.96875 13.5957L8.11161 13.6061L7.54538 14.9172Z",
    fill: "#BF96FF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51562 12.8203L8.1125 13.6062L8.38795 13.499L7.51562 12.8203Z",
    fill: "#BF96FF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96825 13.5958L7.51424 12.8203L6.63672 13.5652L7.51424 12.8203L6.63672 13.5652L6.96825 13.5958L7.51424 12.8203L8.11112 13.6062L8.38657 13.499L7.54488 14.9173L8.11112 13.6062L6.96825 13.5958Z",
    fill: "#BF96FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63672 13.5645L6.96825 13.5951L7.54488 14.9166L6.63672 13.5645Z",
    fill: "#BF96FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51424 12.8203L6.96825 13.5958L6.63672 13.5652L7.51424 12.8203Z",
    fill: "#BF96FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06366 13.1568L5.29883 12.7637L5.49113 13.4218L6.06366 13.1568Z",
    fill: "#BF96FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02539 12.5039L5.31589 13.4143L5.49123 13.4227L5.29893 12.7646L5.02539 12.5039Z",
    fill: "#BF96FF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29893 12.7646L6.06376 13.1577L6.12367 13.0466L5.02539 12.5039L5.29893 12.7646Z",
    fill: "#BF96FF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49219 13.4233L6.41102 13.9961L6.06471 13.1582L5.49219 13.4233Z",
    fill: "#BF96FF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62832 14.2051L6.12418 13.0469L6.62832 14.2051L5.31641 13.4145L5.49175 13.423L6.41058 13.9958L6.62832 14.2051L6.41058 13.9958L6.62832 14.2051Z",
    fill: "#BF96FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02539 12.5039L5.31589 13.4143L5.49123 13.4227L5.29893 12.7646L5.02539 12.5039Z",
    fill: "#BF96FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12436 13.0469L6.06445 13.1579L6.41076 13.9958L6.6285 14.2051L6.12436 13.0469Z",
    fill: "#BF96FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1895 9.96875L11.2108 11.9643L11.8561 11.2033L11.8635 11.1948L11.6578 10.9352L11.768 10.68L11.5929 10.303L11.2743 10.0801L11.1895 9.96875Z",
    fill: "#BF96FF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2754 10.0801L11.6589 10.9352L11.5941 10.303",
    fill: "#BF96FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7681 10.6797L11.816 10.8176L11.8636 11.1945L11.6579 10.9349L11.2109 11.964L11.8636 11.1945L11.7681 10.6797Z",
    fill: "#BF96FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6582 10.9349L11.7684 10.6797L11.8639 11.1945",
    fill: "#BF96FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1895 9.96875L11.4097 10.9718L11.2108 11.9643L11.1895 9.96875Z",
    fill: "#BF96FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4097 10.9718L11.1974 10.9026L11.1895 9.96875L11.4097 10.9718Z",
    fill: "#BF96FF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1211 13.1211L11.2031 14.4202L11.9753 14.23L11.9841 14.2278L11.9723 13.9642L12.1627 13.8506L12.2256 13.5254L12.1239 13.2327L12.1211 13.1211Z",
    fill: "#BF96FF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1242 13.2324L11.9727 13.9639L12.226 13.5251",
    fill: "#BF96FF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1627 13.8516L12.1291 13.9629L11.9841 14.2288L11.9723 13.9651L11.2031 14.4211L11.9841 14.2288L12.1627 13.8516Z",
    fill: "#BF96FF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9727 13.9651L12.163 13.8516L11.9844 14.2288",
    fill: "#BF96FF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1211 13.1211L11.7951 13.872L11.2031 14.4202L12.1211 13.1211Z",
    fill: "#BF96FF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7964 13.872L11.6914 13.7284L12.1225 13.1211L11.7964 13.872Z",
    fill: "#BF96FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28476 16.0586L6.6723 16.3239L6.38672 17.0433L6.87992 16.5991L7.28476 16.0586Z",
    fill: "#BF96FF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87992 16.5991L7.28476 16.0586L6.6723 16.3239L6.87992 16.5991L6.38672 17.0436L7.11106 16.7375",
    fill: "#BF96FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M7.112 16.737L6.88086 16.5986L7.2857 16.0586L7.112 16.737L6.88086 16.5986L7.112 16.737Z",
    fill: "#BF96FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01562 16.3301L9.18393 16.4882L9.12266 16.6567L8.05638 16.4934L8.01562 16.3301Z",
    fill: "#BF96FF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25362 16.1973L9.18222 16.488L8.01392 16.3299L7.58008 16.2178L9.25362 16.1973Z",
    fill: "#BF96FF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05467 16.493L8.01392 16.3297L9.18222 16.4878L9.12095 16.6563L9.18222 16.4878L10.3199 16.2635L9.12095 16.6563L8.05467 16.493L7.58008 16.2175L8.01392 16.3297L7.58008 16.2175L9.49844 15.9062L9.25362 16.197L9.18222 16.4878L9.25362 16.197L10.3199 16.2635L9.49844 15.9062L9.25362 16.197L7.58008 16.2175",
    fill: "#BF96FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3213 16.2637L9.25499 16.1973L9.18359 16.488L10.3213 16.2637Z",
    fill: "#BF96FF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25362 16.197L9.49844 15.9062L7.58008 16.2175L9.25362 16.197Z",
    fill: "#BF96FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00548 16.3103L7.25538 15.9325L5.04105 15.9276L4.86242 15.1113L3.64844 15.4122L5.04105 15.9276L5.00548 16.3103L3.64844 15.4122L4.86242 15.1113L6.43913 15.4275L7.25538 15.9325L5.00548 16.3103L7.25538 15.9325L5.04105 15.9276L4.86242 15.1113L3.64844 15.4122L5.00548 16.3103L5.04105 15.9276L3.64844 15.4122",
    fill: "#BF96FF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25575 15.9326L5.00586 16.3104L5.04142 15.9277L7.25575 15.9326Z",
    fill: "#BF96FF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86242 15.1113L5.04105 15.9276L3.64844 15.4122L4.86242 15.1113Z",
    fill: "#BF96FF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43803 15.4275L4.86133 15.1113L5.03995 15.9276",
    fill: "#BF96FF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9194 14.2749L10.6489 14.3909L10.4473 14.2943L11.3738 13.4414",
    fill: "#BF96FF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11133 15.5236L10.0069 13.9368L11.3738 13.4414L10.9071 14.6127L10.9194 14.2749L11.3738 13.4414L10.4473 14.2943L10.0069 13.9368L11.3738 13.4414L10.4473 14.2943L10.0069 13.9368",
    fill: "#BF96FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11133 15.5243L10.1579 15.1895L9.91582 15.1616L10.1579 15.1895L10.9071 14.6134L10.6489 14.3916L9.91582 15.1616L9.11133 15.5243L10.0069 13.9375L10.4473 14.295L9.11133 15.5243Z",
    fill: "#BF96FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M10.919 14.2754L10.6484 14.3914L10.9067 14.6132L10.919 14.2754Z",
    fill: "#BF96FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91582 15.1615L10.6489 14.3915L10.4473 14.2949L9.11133 15.5242L9.91582 15.1615Z",
    fill: "#BF96FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23828 14.5824L9.32999 13.8887L9.1872 14.8275L8.23828 14.5824Z",
    fill: "#BF96FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23709 14.5824L7.67578 15.7764L8.6299 15.5058L9.18601 14.8275L9.43084 14.807L9.3288 13.8887L8.23709 14.5824Z",
    fill: "#BF96FF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80333 15.5616L8.6299 15.5055L9.18601 14.8272L9.43084 14.8066L8.80333 15.5616L7.67578 15.7761L8.6299 15.5055L8.80333 15.5616Z",
    fill: "#BF96FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1872 14.8275L8.23828 14.5824L9.32999 13.8887L9.1872 14.8275Z",
    fill: "#BF96FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80333 15.5619L8.6299 15.5059L7.67578 15.7764L8.80333 15.5619Z",
    fill: "#BF96FF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1312 5.46465C18.1312 4.70987 17.549 4.00977 16.7231 4.00977C15.8972 4.00977 15.315 4.70987 15.315 5.46465V7.8866H13.1034C12.2775 7.8866 11.6953 8.5867 11.6953 9.34148C11.6953 10.0963 12.2775 10.7964 13.1034 10.7964H15.315V13.2183C15.315 13.9731 15.8972 14.6732 16.7231 14.6732C17.549 14.6732 18.1312 13.9731 18.1312 13.2183V10.7964H20.3428C21.1686 10.7964 21.7509 10.0963 21.7509 9.34148C21.7509 8.5867 21.1686 7.8866 20.3428 7.8866H18.1312V5.46465Z",
    fill: "#BF96FF",
    stroke: "#19162D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateArcana);
export default __webpack_public_path__ + "static/media/createArcana.26dd74bef7e50d77687b64d29f0459c6.svg";
export { ForwardRef as ReactComponent };